import { render, staticRenderFns } from "./ProblemEditorModal.vue?vue&type=template&id=e42c4cc4&scoped=true&"
import script from "./ProblemEditorModal.vue?vue&type=script&lang=js&"
export * from "./ProblemEditorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42c4cc4",
  null
  
)

component.options.__file = "ProblemEditorModal.vue"
export default component.exports